/** Read-only listeners on the diagnostic log (listening-session telemetry). They see every line and cannot alter it. */
type Observed = { level: string; category: string; message: string; payload?: Record<string, unknown> };
const observers = new Set<(e: Observed) => void>();

export function observeDiagnosticEvents(fn: (e: Observed) => void): () => void {
  observers.add(fn);
  return () => { observers.delete(fn); };
}

export function notifyDiagnosticObservers(e: Observed): void {
  for (const fn of observers) { try { fn(e); } catch { /* observers never break logging */ } }
}
